// extracted by mini-css-extract-plugin
module.exports =  {"mobileAuthenticationTooltip":"mobileAuthenticationTooltip___7y91T","phoneVerificationTooltip":"phoneVerificationTooltip___SQskQ"};